import axios from 'axios';

const GetHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

const PostHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

export const get = (url, params, headers = {}) => {
    const options = {
        headers: {
            ...GetHeaders,
            ...headers,
        },
    };
    if (params && Object.keys(params).length > 0) {
        options.params = params;
    }
    return axios.get(url, options).then((response) => response.data);
};

export const post = (url, data, headers = {}, options = {}) =>
    axios
        .post(url, data, {
            headers: {
                ...PostHeaders,
                ...headers,
            },
            ...options,
        })
        .then((response) => response.data);

export const put = (url, data, headers = {}, options = {}) =>
    axios
        .put(url, data, {
            headers: {
                ...PostHeaders,
                ...headers,
            },
            ...options,
        })
        .then((response) => response.data);

export const del = (url, data, headers = {}, options = {}) =>
    axios
        .delete(url, data, {
            headers: {
                ...PostHeaders,
                ...headers,
            },
            ...options,
        })
        .then((response) => response.data);

export const paramsToQueryString = (data) => {
    const params = new URLSearchParams();
    Object.entries(data).map((x) => params.append(x[0], x[1]));
    return params;
};

export const extractJsonFromXML = (data) => {
    let responseDoc = new JSON.parse(data, 'application/xml');
    let jsonText = responseDoc.getElementsByTagName('string')[0].textContent;
    return JSON.parse(jsonText);
};
